import React from 'react'
import { FileManager, FileNavigator } from '@opuscapita/react-filemanager';
import Styles from "./fileExplorer.module.scss";
import connectorNodeV1 from '@opuscapita/react-filemanager-connector-node-v1';
import config from 'services/config';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { FileUploader, FileManager as Uploader } from 'reactjs-file-uploader';
import PictureCrop from '../pictureCrop/pictureCrop';

const apiOptions = {
  ...connectorNodeV1.apiOptions,
  apiRoot: config.wsUrl
}

interface IFileExplorerState {
  modal: boolean,
  modalCrop: boolean,
  files: any[],
  currentFolder: string,
  currentPicturePreview?: string
  currentPicturePreviewRelative?: string,
  currentPicturePreviewItem?: any
}

interface IFileExplorerProps {
  onClick?: Function,
  onDblClick?: Function
}
export default class FileExplorer extends React.Component<IFileExplorerProps, IFileExplorerState> {

  /**
   *
   */
  constructor(props: IFileExplorerProps) {
    super(props);

    this.state = { modal: false, modalCrop: false, files: [], currentFolder: '', currentPicturePreview: '', currentPicturePreviewRelative: '' }
  }

  FileNavigator: any

  render() {
    this.FileNavigator = <FileNavigator
      id="filemanager-1"
      api={connectorNodeV1.api}
      apiOptions={apiOptions}
      capabilities={this.capabilities.bind(this)}
      listViewLayout={connectorNodeV1.listViewLayout}
      viewLayoutOptions={connectorNodeV1.viewLayoutOptions}
      onResourceItemClick={(any: any) => {
        if (any.rowData.type == 'file' && isPicture(any.rowData.name)) {
          var pictureRelativeUrl = `${encodeURI(config.rootFolderPath)}${encodeURI(computeFullPath(any.rowData))}`;
          var pictureUrl = `${encodeURI(config.wsUrl != '' ? config.wsUrl : window.location.origin)}/${pictureRelativeUrl}`;
          this.setState({ currentPicturePreview: pictureUrl, currentPicturePreviewRelative: pictureRelativeUrl, currentPicturePreviewItem: any.rowData })
        }
        else {
          this.setState({ currentPicturePreview: undefined, currentPicturePreviewRelative: undefined, currentPicturePreviewItem: undefined })
        }
        if (this.props.onClick) {
          this.props.onClick(any)
        }
      }
      }
      onResourceItemDoubleClick={this.props.onDblClick}
      onResourceLocationChange={
        (resourceLocation: any) => this.setState({ currentFolder: resourceLocation[resourceLocation.length - 1].id })
      }
    />;
    return (
      <div className={Styles.FileExplorer}>
        <div className={Styles.pictPreview}>
          {this.state.currentPicturePreview ?
            <img style={{ width: "100%" }} src={this.state.currentPicturePreview} />
            : null
          }
        </div>
        <FileManager>
          {this.FileNavigator}
          <Modal isOpen={this.state.modal}>
            <ModalHeader toggle={this.toggle.bind(this)}>Upload multiple</ModalHeader>
            <ModalBody style={{ minHeight: '300px' }}>
              <input
                type="file"
                accept="image/*"
                onChange={event => this.setState({ files: this.state.files.concat(Array.from(event.target.files || [])) })}
                multiple
              />
              <Uploader
                files={this.state.files}
              >
                {this.uploadFiles.bind(this)}
              </Uploader>
            </ModalBody>
          </Modal>
          <Modal isOpen={this.state.modalCrop}>
            <ModalHeader toggle={this.toggleCrop.bind(this)}>Rendu d'image</ModalHeader>
            <ModalBody style={{ minHeight: '300px' }}>
              <PictureCrop PictureUrl={this.state.currentPicturePreview || ''} Picturedata={this.state.currentPicturePreviewItem || undefined} OnSave={this.toggleCrop.bind(this)} />
            </ModalBody>
          </Modal>
        </FileManager>
      </div>
    )
  }

  uploadFiles(files: any[]) {
    return files.map((f) => { return this.uploadFile(f) });
  }

  uploadFile(file: any) {
    return (
      <FileUploader
        key={file.key}
        file={file}
        url={`${config.wsUrl}/files`}
        formData={{
          type: 'file',
          parentId: this.state.currentFolder,
          files: file
        }}
        readFile
        autoUpload
      >
        {this.fileProgress.bind(this)}
      </FileUploader>
    )
  }

  capabilities(apiOptions: any, actions: any) {
    var arr = connectorNodeV1.capabilities(apiOptions, actions) as any[];
    arr.splice(1, 0, {
      id: 'multipleUpload',
      icon: {
        svg: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" 
        width="80" height="80"
        viewBox="0 0 80 80"
        style=" fill:#000000;"><g id="surface1"><path style=" " d="M 40 4.6875 L 29.394531 15.292969 L 30.808594 16.707031 L 39 8.515625 L 39 48 L 41 48 L 41 8.515625 L 49.191406 16.707031 L 50.605469 15.292969 Z M 15 14 C 12.25 14 10 16.25 10 19 L 10 65 C 10 67.75 12.25 70 15 70 L 65 70 C 67.75 70 70 67.75 70 65 L 70 19 C 70 16.25 67.75 14 65 14 L 57 14 L 57 16 L 65 16 C 66.667969 16 68 17.332031 68 19 L 68 65 C 68 66.667969 66.667969 68 65 68 L 15 68 C 13.332031 68 12 66.667969 12 65 L 12 19 C 12 17.332031 13.332031 16 15 16 L 23 16 L 23 14 Z M 18 21 C 17.449219 21 17 21.449219 17 22 C 17 22.550781 17.449219 23 18 23 C 18.550781 23 19 22.550781 19 22 C 19 21.449219 18.550781 21 18 21 Z M 22 21 C 21.449219 21 21 21.449219 21 22 C 21 22.550781 21.449219 23 22 23 C 22.550781 23 23 22.550781 23 22 C 23 21.449219 22.550781 21 22 21 Z M 58 21 C 57.449219 21 57 21.449219 57 22 C 57 22.550781 57.449219 23 58 23 C 58.550781 23 59 22.550781 59 22 C 59 21.449219 58.550781 21 58 21 Z M 62 21 C 61.449219 21 61 21.449219 61 22 C 61 22.550781 61.449219 23 62 23 C 62.550781 23 63 22.550781 63 22 C 63 21.449219 62.550781 21 62 21 Z M 18 25 C 17.449219 25 17 25.449219 17 26 C 17 26.550781 17.449219 27 18 27 C 18.550781 27 19 26.550781 19 26 C 19 25.449219 18.550781 25 18 25 Z M 62 25 C 61.449219 25 61 25.449219 61 26 C 61 26.550781 61.449219 27 62 27 C 62.550781 27 63 26.550781 63 26 C 63 25.449219 62.550781 25 62 25 Z M 18 29 C 17.449219 29 17 29.449219 17 30 C 17 30.550781 17.449219 31 18 31 C 18.550781 31 19 30.550781 19 30 C 19 29.449219 18.550781 29 18 29 Z M 62 29 C 61.449219 29 61 29.449219 61 30 C 61 30.550781 61.449219 31 62 31 C 62.550781 31 63 30.550781 63 30 C 63 29.449219 62.550781 29 62 29 Z M 18 33 C 17.449219 33 17 33.449219 17 34 C 17 34.550781 17.449219 35 18 35 C 18.550781 35 19 34.550781 19 34 C 19 33.449219 18.550781 33 18 33 Z M 62 33 C 61.449219 33 61 33.449219 61 34 C 61 34.550781 61.449219 35 62 35 C 62.550781 35 63 34.550781 63 34 C 63 33.449219 62.550781 33 62 33 Z M 18 37 C 17.449219 37 17 37.449219 17 38 C 17 38.550781 17.449219 39 18 39 C 18.550781 39 19 38.550781 19 38 C 19 37.449219 18.550781 37 18 37 Z M 62 37 C 61.449219 37 61 37.449219 61 38 C 61 38.550781 61.449219 39 62 39 C 62.550781 39 63 38.550781 63 38 C 63 37.449219 62.550781 37 62 37 Z M 18 41 C 17.449219 41 17 41.449219 17 42 C 17 42.550781 17.449219 43 18 43 C 18.550781 43 19 42.550781 19 42 C 19 41.449219 18.550781 41 18 41 Z M 62 41 C 61.449219 41 61 41.449219 61 42 C 61 42.550781 61.449219 43 62 43 C 62.550781 43 63 42.550781 63 42 C 63 41.449219 62.550781 41 62 41 Z M 18 45 C 17.449219 45 17 45.449219 17 46 C 17 46.550781 17.449219 47 18 47 C 18.550781 47 19 46.550781 19 46 C 19 45.449219 18.550781 45 18 45 Z M 62 45 C 61.449219 45 61 45.449219 61 46 C 61 46.550781 61.449219 47 62 47 C 62.550781 47 63 46.550781 63 46 C 63 45.449219 62.550781 45 62 45 Z M 18 49 C 17.449219 49 17 49.449219 17 50 C 17 50.550781 17.449219 51 18 51 C 18.550781 51 19 50.550781 19 50 C 19 49.449219 18.550781 49 18 49 Z M 62 49 C 61.449219 49 61 49.449219 61 50 C 61 50.550781 61.449219 51 62 51 C 62.550781 51 63 50.550781 63 50 C 63 49.449219 62.550781 49 62 49 Z M 18 53 C 17.449219 53 17 53.449219 17 54 C 17 54.550781 17.449219 55 18 55 C 18.550781 55 19 54.550781 19 54 C 19 53.449219 18.550781 53 18 53 Z M 62 53 C 61.449219 53 61 53.449219 61 54 C 61 54.550781 61.449219 55 62 55 C 62.550781 55 63 54.550781 63 54 C 63 53.449219 62.550781 53 62 53 Z M 18 57 C 17.449219 57 17 57.449219 17 58 C 17 58.550781 17.449219 59 18 59 C 18.550781 59 19 58.550781 19 58 C 19 57.449219 18.550781 57 18 57 Z M 62 57 C 61.449219 57 61 57.449219 61 58 C 61 58.550781 61.449219 59 62 59 C 62.550781 59 63 58.550781 63 58 C 63 57.449219 62.550781 57 62 57 Z M 18 61 C 17.449219 61 17 61.449219 17 62 C 17 62.550781 17.449219 63 18 63 C 18.550781 63 19 62.550781 19 62 C 19 61.449219 18.550781 61 18 61 Z M 22 61 C 21.449219 61 21 61.449219 21 62 C 21 62.550781 21.449219 63 22 63 C 22.550781 63 23 62.550781 23 62 C 23 61.449219 22.550781 61 22 61 Z M 26 61 C 25.449219 61 25 61.449219 25 62 C 25 62.550781 25.449219 63 26 63 C 26.550781 63 27 62.550781 27 62 C 27 61.449219 26.550781 61 26 61 Z M 30 61 C 29.449219 61 29 61.449219 29 62 C 29 62.550781 29.449219 63 30 63 C 30.550781 63 31 62.550781 31 62 C 31 61.449219 30.550781 61 30 61 Z M 34 61 C 33.449219 61 33 61.449219 33 62 C 33 62.550781 33.449219 63 34 63 C 34.550781 63 35 62.550781 35 62 C 35 61.449219 34.550781 61 34 61 Z M 38 61 C 37.449219 61 37 61.449219 37 62 C 37 62.550781 37.449219 63 38 63 C 38.550781 63 39 62.550781 39 62 C 39 61.449219 38.550781 61 38 61 Z M 42 61 C 41.449219 61 41 61.449219 41 62 C 41 62.550781 41.449219 63 42 63 C 42.550781 63 43 62.550781 43 62 C 43 61.449219 42.550781 61 42 61 Z M 46 61 C 45.449219 61 45 61.449219 45 62 C 45 62.550781 45.449219 63 46 63 C 46.550781 63 47 62.550781 47 62 C 47 61.449219 46.550781 61 46 61 Z M 50 61 C 49.449219 61 49 61.449219 49 62 C 49 62.550781 49.449219 63 50 63 C 50.550781 63 51 62.550781 51 62 C 51 61.449219 50.550781 61 50 61 Z M 54 61 C 53.449219 61 53 61.449219 53 62 C 53 62.550781 53.449219 63 54 63 C 54.550781 63 55 62.550781 55 62 C 55 61.449219 54.550781 61 54 61 Z M 58 61 C 57.449219 61 57 61.449219 57 62 C 57 62.550781 57.449219 63 58 63 C 58.550781 63 59 62.550781 59 62 C 59 61.449219 58.550781 61 58 61 Z M 62 61 C 61.449219 61 61 61.449219 61 62 C 61 62.550781 61.449219 63 62 63 C 62.550781 63 63 62.550781 63 62 C 63 61.449219 62.550781 61 62 61 Z "></path></g></svg>`
      },
      label: 'Upload multiple',
      shouldBeAvailable: () => true,
      availableInContexts: ['toolbar'],
      handler: this.toggle.bind(this)
    }, {
        id: 'crop',
        icon: {
          svg: `<svg id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m497 361h-46v-235c0-12.238-3.404-23.694-9.308-33.479l49.915-49.915c5.858-5.857 5.858-15.355 0-21.213-5.856-5.857-15.354-5.858-21.213 0l-49.688 49.688c-10.051-6.373-21.95-10.081-34.706-10.081h-235v-46c0-8.284-6.716-15-15-15h-60c-8.284 0-15 6.716-15 15v46h-46c-8.284 0-15 6.716-15 15v60c0 8.284 6.716 15 15 15h46v235c0 12.756 3.708 24.656 10.082 34.705l-50.188 50.188c-5.858 5.857-5.858 15.355 0 21.213 5.857 5.858 15.355 5.858 21.213 0l50.415-50.415c9.784 5.905 21.24 9.309 33.478 9.309h235v46c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-46h46c8.284 0 15-6.716 15-15v-60c0-8.284-6.716-15-15-15zm-406-331h30v31h-30zm35 391c-19.299 0-35-15.701-35-35v-235h30v225c0 8.284 6.716 15 15 15h225v30zm235-60h-187.787l187.787-187.787zm-210-20.213v-189.787h189.787zm270 141.213h-30v-346c0-8.284-6.716-15-15-15h-346v-30h356c19.299 0 35 15.701 35 35zm61-61h-31v-30h31z"/></svg>`
        },
        label: 'Rendu de l\'image',
        shouldBeAvailable: () => this.state.currentPicturePreview,
        availableInContexts: ['toolbar'],
        handler: this.toggleCrop.bind(this)
      });
    return arr;
  }

  fileProgress(arg: any) {
    return (
      <div>
        {arg.fileData && <img src={arg.fileData} width={200} alt="Preview" />}
        {arg.startUpload && <button onClick={arg.startUpload}>Upload File</button>}
        {arg.requestState && arg.requestState}
      </div>
    )
  }

  toggle() {
    this.setState({ modal: !this.state.modal, files: [] });
    var currentButton = document.getElementsByClassName("oc-fm--location-bar__item--last")[0] as HTMLElement
    currentButton.click();
  }

  toggleCrop() {
    this.setState({ modalCrop: !this.state.modalCrop });
    var currentButton = document.getElementsByClassName("oc-fm--location-bar__item--last")[0] as HTMLElement
    currentButton.click();
  }
}

export function computeFullPath(file: any) {
  let str = "";
  file.ancestors.forEach((ancestor: any) => {
    if (ancestor.ancestors.length != 0)
      str += "/" + ancestor.name
  });

  str += "/" + file.name
  return str;
}

export function isPicture(str: string) {
  return str.toLowerCase().endsWith(".jpg")
    || str.toLowerCase().endsWith(".png")
    || str.toLowerCase().endsWith(".bmp")
    || str.toLowerCase().endsWith(".jpeg")
    || str.toLowerCase().endsWith(".gif")
    || str.toLowerCase().endsWith(".webp")
}
